import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import entities from './entities/index';
import views from './views/index';
import ui from './ui/index';
import session from './session/index';
import aggregatedData from './aggregated-data';

export default function createReducers(history) {
	return combineReducers({
		router: connectRouter(history),
		config: (state = {}) => state,
		entities,
		views,
		ui,
		session,
		aggregatedData,
	});
}
